import { message } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Order from "../../api/orderApi";
import { InfoUserOrderAction } from "../../appRedux/action/OrderAction";
import { FooterConfig, NavbarScreen, SupportScreen } from "../../components";

import FormSearch from "./components/FormSearch";
import TableRegister from "./components/TableRegister";
const ManageRegisterVaccination = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [vaccines, setVaccines] = useState([]);

  useEffect(() => {
    getList();
  }, []);

  const getOrderDetail = async () => {
    await dispatch(InfoUserOrderAction());
  };
  const getVaccines = async () => {
    const result = await Order.getVaccines();

    setVaccines(result.data || []);
  };

  // console.log(pathogens);
  const getList = async () => {
    const token = await localStorage.getItem("USER_TOKEN");
    const userId = await localStorage.getItem("USER_ID");

    if (!token || !userId) {
      message.error("Bạn chưa đăng nhập");
      Order.logOutUser();
      return history.replace("/login");
    }

    Promise.all([getVaccines(), getOrderDetail()]);
  };

  const dataSearch = (data) => {
    console.log(data);
  };

  return (
    <>
      <NavbarScreen />
      <div className="ManageRegisterVaccination container">
        <div className="row">
          <div className="content__left col-md-9 col-sm-12 p-0">
            <h1 className="content__title--one">
              {" "}
              Danh sách đăng ký tiêm chủng
            </h1>

            <FormSearch vaccines={vaccines} />
          </div>
          <div className="content__right col-md-3 col-sm-12 pr-0">
            <SupportScreen />
          </div>
          <div className="col-12 p-0 m-0">
            <TableRegister />
          </div>
        </div>
      </div>

      <FooterConfig />
    </>
  );
};

export default ManageRegisterVaccination;
